<template>
    <v-card>
        <v-card-title>
            Event: {{event_obj.title}}
            <v-spacer></v-spacer>
            <v-btn icon @click="$emit('close_registrations')">
                <v-icon>close</v-icon>
            </v-btn>
        </v-card-title>
        <v-card-subtitle>
            Registrations
        </v-card-subtitle>
        <v-card-text>

            <v-row>
                <!-- <v-col xs4>
                    <v-btn color="success" @click="checkinAttendee()">Start Check-ins</v-btn>
                </v-col> -->
                <v-col xs8>
                    <v-spacer></v-spacer>
                    <v-text-field label="search" v-model="search" prepend-icon="search"></v-text-field>
                </v-col>
            </v-row>
            <v-data-table :headers="headers" :loading="loading" :items="registrations?registrations:[]"
                :search="search">
                <template v-slot:item.approval_status="{ item }">
                    <v-chip color="success" v-if="item.approval_status=='approved'">
                        approved
                    </v-chip>
                    <v-chip color="error" v-else>
                        pending
                    </v-chip>
                </template>
                <template v-slot:item.actions="{ item }">
                    <v-btn color="success" @click="onApprove(item)" :disabled="item.approval_status=='approved'">
                        Approve
                    </v-btn>
                </template>
            </v-data-table>

        </v-card-text>
    </v-card>
</template>

<script>

import { db } from '../../config/firebasedb'
import emailService from '../../services/email.service'
export default {
    props: {
        event_obj: Object
    },
    data: () => ({
        search: "",
        loading: false,
        error: "",
        headers: [
            {
                text: 'Name',
                align: 'start',
                sortable: false,
                value: 'name',
            },
            { text: 'E-mail', value: 'email' },
            { text: 'Phone', value: 'phone' },
            { text: 'Company', value: 'company_name' },
            { text: 'Registratoin Date & Time', value: 'registration_date' },
            { text: 'Approval Status', value: 'approval_status' },
            { text: 'Actions', value: 'actions' },
        ],
        registrations: []
    }),
    async created() {
        this.loading = true
        await db.collection("events")
            .doc(this.event_obj.id)
            .collection("registrations")
            .onSnapshot(snap => {
                this.registrations = []
                snap.forEach(doc => {
                    var registration = doc.data()
                    registration.id = doc.id
                    registration.registration_date = `${new Date(registration.registration_date).toDateString()} @ ${new Date(registration.registration_date).toLocaleTimeString()}`
                    this.registrations.unshift(registration)
                })
                this.loading = false
            })
    },
    methods: {
        async onApprove(registration) {
            if (confirm("Please note that this action cannot be changed. Always verify registration details before approval. Do you wish to continue?")) {
                this.loading = true
                await db.collection("events")
                    .doc(this.event_obj.id)
                    .collection("registrations")
                    .doc(registration.id)
                    .update({
                        approval_status: "approved",
                    }).then(async() => {
                        var baseUrl = window.location.origin
                        var evPassLink = `${baseUrl}/eventpass/${this.event_obj.title}/${registration.id}`
                        emailService.sendEmail(registration.name,registration.email,this.event_obj.title,evPassLink)
                        this.$toast.success("Approval successful")
                    }).catch(err => {
                        console.log(err)
                        this.$toast.error("An error occured and check-in was not successful")
                    })
                this.loading = false
            }
        },

    }
}
</script>
